import React from 'react';
import { SiteSection, SiteSectionHeader } from '../../components/site';
import type { SolutionPremiumSections } from './types';

export const SolutionIndustriesConvergence: React.FC<{
  verticals: SolutionPremiumSections['verticals'];
}> = ({ verticals }) => {
  const { sceneImage, convergence, items } = verticals;

  if (!sceneImage || !convergence || items.length < 2) {
    return null;
  }

  return (
    <SiteSection id="offerings" className="solution-floor-auto mf-industries">
      <SiteSectionHeader
        eyebrow={verticals.eyebrow}
        title={verticals.title}
        subtitle={verticals.subtitle}
        align="center"
      />

      <div className="mf-industries__wrap">
        <div className="mf-industries__stage">
          <div className="mf-industries__scene" aria-hidden>
            <img
              src={sceneImage.src}
              alt=""
              width={sceneImage.width}
              height={sceneImage.height}
              loading="lazy"
              decoding="async"
            />
            <div className="mf-industries__scene-vignette" />
          </div>

          <div className="mf-industries__cards">
            {items.map((item, index) => (
              <article
                key={item.id}
                className={`mf-industries__card mf-industries__card--${index === 0 ? 'discrete' : 'process'}`}
                style={{ '--card-i': index } as React.CSSProperties}
              >
                <div className="mf-industries__card-glass">
                  <h3 className="mf-industries__card-title">{item.label}</h3>
                  <ul className="mf-industries__list">
                    {item.bullets.map((bullet) => (
                      <li key={bullet}>{bullet}</li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>

          <div className="mf-industries__convergence">
            <div className="mf-industries__convergence-glass">
              <h4 className="mf-industries__convergence-title">{convergence.title}</h4>
              <p className="mf-industries__convergence-subtitle">{convergence.subtitle}</p>
            </div>
          </div>
        </div>
      </div>
    </SiteSection>
  );
};
